import { IconProps } from '../types';

function SquareSeparateSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M3,3h5v5H3V3z M12,3h5v5h-5V3z M3,12h5v5H3V12z M12,12h5v5h-5V12z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default SquareSeparateSolidIcon;
